export default __webpack_public_path__ + "static/msscLogo-83b0e4626a3cb3ffd7238e1b833de92a.png";